import React from 'react';
import ReactDOM from 'react-dom/client';
import { ClerkProvider } from './auth/clerk';
import './index.css';
import './mobile.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Initialize capture services BEFORE React renders (Bug Tracking Phase 1)
import { initConsoleCapture } from './services/consoleCapture';
import { initNetworkCapture } from './services/networkCapture';

initConsoleCapture();
initNetworkCapture();

// Get Clerk publishable key from environment
const clerkPubKey = process.env.REACT_APP_CLERK_PUBLISHABLE_KEY;

if (!clerkPubKey) {
  console.warn('Missing REACT_APP_CLERK_PUBLISHABLE_KEY - auth will not work');
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ClerkProvider
      publishableKey={clerkPubKey || ''}
      signInUrl="/sign-in"
      signUpUrl="/sign-up"
      signInFallbackRedirectUrl="/projects"
      signUpFallbackRedirectUrl="/projects"
      signUpForceRedirectUrl="/projects"
      afterSignOutUrl="/sign-in"
    >
      <App />
    </ClerkProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
